<template>
  <div class="one-column-width">
    <!-- show action result -->
    <v-snackbar v-model="snackbar" absolute top right color="success">
      <span>{{ snackBarText }}</span>
      <v-icon dark>mdi-checkbox-marked-circle</v-icon>
    </v-snackbar>

    <v-snackbar v-model="errorMessage" absolute top right color="danger">
      <span>Something went RONG, Please Try Again!</span>
      <v-icon dark>mdi-checkbox-marked-circle</v-icon>
    </v-snackbar>

    <!-- Confirm Delete Item -->

    <v-row justify="center">
      <v-dialog v-model="dialog" persistent max-width="380px">
        <v-card>
          <v-card-title>
            <span class="headline">Do you really want to DELETE this item?</span>
          </v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn class="custom-submit-button" text @click="dialog = false">No</v-btn>
            <v-btn class="custom-cancel-button" text @click="deleteItem"
              ><b-spinner small type="grow" v-if="deleting"></b-spinner>Delete</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <!-- form start -->
    <v-card class="add-form-title" v-if="showFormData">
      <v-card-title> Add New Admission Form Tab Fields </v-card-title>
      <div>
        <v-form ref="form" @submit.prevent="submit" class="custom-form">
          <v-container fluid>
            <v-col cols="12" sm="12">
              <v-row v-for="(item, index) in form" :key="index">
                <v-autocomplete
                  v-model="item.tab_id"
                  :rules="rules.tab_id"
                  :items="tabsData"
                  label="Select tab"
                  class="col-md-3"
                ></v-autocomplete>
                <v-text-field
                  v-model="item.caption"
                  :rules="rules.caption"
                  color="purple name-2"
                  label="Caption"
                  class="col-md-3"
                  required
                ></v-text-field>
                <v-text-field
                  v-model="item.label"
                  :rules="rules.label"
                  color="purple name-2"
                  label="Field Label"
                  class="col-md-3"
                  required
                ></v-text-field>
                <v-text-field
                  v-model="item.sequence"
                  :rules="rules.sequence"
                  color="purple name-2"
                  label="sequence"
                  class="col-md-3"
                  required
                ></v-text-field>
                <v-autocomplete
                  v-model="item.type"
                  :rules="rules.type"
                  :items="types"
                  label="Select type"
                  class="col-md-2"
                  @change="(event) => checkSelectedValue(index, event)"
                ></v-autocomplete>
                <v-text-field
                  v-model="item.length"
                  :rules="rules.length"
                  color="purple name-2"
                  label="length"
                  class="col-md-2"
                  required
                ></v-text-field>
                <v-radio-group v-model="item.editable" row class="col-md-3">
                  <v-radio label="Show" value="1"></v-radio>
                  <v-radio label="Hide" value="0"></v-radio>
                </v-radio-group>
                <v-radio-group v-model="item.frontend" row class="col-md-3">
                  <v-radio label="Optional " value="0"></v-radio>
                  <v-radio label="Mandatory" value="1"></v-radio>
                </v-radio-group>
                <v-text-field
                  v-model="item.options"
                  :rules="rules.options"
                  color="purple name-2"
                  label="Enter Select Options with comma separated values"
                  class="col-md-11 custom-options-width"
                  v-if="item.showSelectOptions"
                ></v-text-field>
                <template v-if="!editId">
                  <v-btn
                    class="custom-add-new-record-button"
                    type="button"
                    @click="addNewRow()"
                    >+</v-btn
                  >
                  <v-btn
                    v-if="index > 0"
                    class="custom-delete-new-record-button"
                    type="button"
                    @click="deleteRow(index)"
                    >-</v-btn
                  >
                </template>
              </v-row>
            </v-col>
          </v-container>
          <v-card-actions>
            <v-btn
              :disabled="$v.$invalid || submitting"
              class="custom-submit-button"
              type="submit"
              ><b-spinner small type="grow" v-if="submitting"></b-spinner>
              <span v-if="!editId">Submit</span>
              <span v-if="editId">Update</span>
            </v-btn>
            <v-btn text @click="cancelForm" class="custom-cancel-button">Cancel</v-btn>
          </v-card-actions>
        </v-form>
      </div>
    </v-card>
    <!-- form end -->

    <!-- table start -->
    <v-card>
      <v-card-title>
        Admission Form Tab Fields
        <div class="my-2 ml-2">
          <v-btn
            class="btn btn-sm btn-success font-weight-bold py-2 px-3 px-xxl-5 my-1"
            fab
            small
            @click="showForm"
          >
            <v-icon dark>mdi-plus</v-icon>
          </v-btn>
        </div>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="search"
          label="Search fields"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table :headers="headers" :items="tableData" :search="search">
        <template v-slot:[`item.actions`]="{ item }">
          <v-btn
            class="btn btn-sm btn-success font-weight-bold py-2 px-3 px-xxl-5 my-1"
            fab
            small
            @click="showEditForm(item)"
          >
            <v-icon dark>mdi-pencil</v-icon>
          </v-btn>
          &nbsp;
          <v-btn
            class="btn btn-sm btn-danger font-weight-bold py-2 px-3 px-xxl-5 my-1"
            fab
            small
            @click="askUserAboutDelete(item)"
          >
            <v-icon dark>mdi-delete</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-card>

    <!-- table end -->
  </div>
</template>

<script>
import AdmissionForm from "@/MainServices/AdmissionForm.js";
import { required, minLength } from "vuelidate/lib/validators";
export default {
  data() {
    return {
      form: [
        {
          tab_id: null,
          caption: "",
          label: "",
          sequence: "",
          length: null,
          type: "",
          frontend: null,
          editable: null,
          options: null,
          showSelectOptions: null,
        },
      ],
      editId: null,
      deleteId: null,
      dialog: false,
      rules: {
        tab_id: [(val) => !!val || "Tab is required"],
        caption: [(val) => (val || "").length > 0 || "Caption is required"],
        label: [(val) => (val || "").length > 0 || "label is required"],
        length: [(val) => (val || "").length > 0 || "length is required"],
        frontend: [(val) => (val || "").length > 0 || "This Option is required"],
        editable: [(val) => (val || "").length > 0 || "This Option is required"],
        type: [(val) => (val || "").length > 0 || "type is required"],
        sequence: [(val) => (val || "").length > 0 || "Sequence is required"],
      },
      snackbar: false,
      snackBarText: null,
      submitting: false,
      deleting: false,
      errorMessage: false,
      search: "",
      showFormData: false,
      headers: [
        {
          text: "Tab",
          align: "left",
          sortable: false,
          value: "addmision_form_tabs.name",
          width: "20%",
        },
        {
          text: "Caption",
          align: "left",
          sortable: false,
          value: "caption",
          width: "20%",
        },
        { text: "Label", align: "left", sortable: false, value: "label", width: "20%" },
        {
          text: "Sequence",
          align: "left",
          sortable: false,
          value: "sequence",
          width: "15%",
        },
        { text: "Type", align: "left", sortable: false, value: "type", width: "15%" },

        { text: "Actions", value: "actions", sortable: false },
      ],
      tableData: [],
      tabsData: [],
      types: [
        { value: "text", text: "text" },
        { value: "textarea", text: "textarea" },
        { value: "date", text: "date" },
        { value: "file", text: "file" },
        { value: "break", text: "Line Break" },
        { value: "integer", text: "integer" },
        { value: "checkbox", text: "checkbox" },
        { value: "radiobutton", text: "radiobutton" },
        { value: "select", text: "select" },
        { value: "multiselect", text: "multiselect" },
      ],
    };
  },
  validations: {
    form: {
      required,
      $each: {
        tab_id: { minLength: minLength(1), required },
        caption: { minLength: minLength(1), required },
        label: { minLength: minLength(1), required },
        sequence: { minLength: minLength(1), required },
        length: { minLength: minLength(1), required },
        type: { minLength: minLength(1), required },
        frontend: { minLength: minLength(1), required },
        editable: { minLength: minLength(1), required },
      },
    },
  },
  components: {},

  computed: {},

  methods: {
    getInititalData() {
      AdmissionForm.getFormFields()
        .then((res) => {
          this.tableData = res.data;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    checkSelectedValue(index, event) {
      if (event == "select") {
        this.form[index].showSelectOptions = true;
      } else {
        this.form[index].showSelectOptions = false;
      }
    },

    // main methods
    showForm() {
      this.editId = null;
      this.showFormData = true;
      this.resetForm();
    },
    showEditForm(item) {
      this.form = [
        {
          tab_id: item.tab_id,
          caption: item.caption,
          label: item.label,
          sequence: item.sequence,
          length: item.length,
          type: item.type,
          frontend: item.frontend,
          editable: item.editable,
        },
      ];
      this.editId = item.id;
      this.showFormData = true;
    },
    cancelForm() {
      this.resetForm();

      this.showFormData = false;
    },
    resetForm() {
      this.form = [
        {
          tab_id: null,
          caption: "",
          label: "",
          sequence: "",
          length: null,
          type: "",
          frontend: null,
          editable: null,
          showSelectOptions: false,
          options: null,
        },
      ];
      this.editId = null;
      setTimeout(() => {
        this.$refs.form.reset();
      }, 100);
    },
    addNewRow() {
      this.form.push({
        tab_id: null,
        caption: "",
        label: "",
        sequence: "",
        length: null,
        type: "",
        frontend: null,
        editable: null,
        showSelectOptions: false,
        options: null,
      });
    },
    deleteRow(index) {
      this.form.splice(index, 1);
    },
    submit() {
      this.submitting = true;
      if (this.editId) {
        AdmissionForm.editField(this.form, this.editId)
          .then((res) => {
            this.resetForm();
            this.getInititalData();
            this.submitting = false;
            this.snackBarText = "Fields Updated successful!";
            this.snackbar = true;
          })
          .catch((error) => {
            this.errorMessage = true;
          });
      } else {
        // this.form.map((el) => {
        //   if (el.options !== null) {
        //     el.options = el.options.split(",");
        //   }
        // });

        AdmissionForm.addNewFields(this.form)
          .then((res) => {
            this.resetForm();
            this.getInititalData();
            this.submitting = false;
            this.snackBarText = "Fields Added successful!";
            this.snackbar = true;
          })
          .catch((error) => {
            this.errorMessage = true;
          });
      }
    },
    askUserAboutDelete(item) {
      this.deleteId = item.id;
      this.dialog = true;
    },
    deleteItem() {
      this.deleting = true;
      AdmissionForm.deleteField(this.deleteId)
        .then((res) => {
          this.editId = null;
          this.deleting = false;
          this.dialog = false;
          this.resetForm();
          this.getInititalData();
          this.snackBarText = "Field Deleted successful!";
          this.snackbar = true;
        })
        .catch((error) => {
          this.errorMessage = true;
          this.dialog = false;
        });
    },
  },
  mounted() {
    this.getInititalData();
    AdmissionForm.getFormTabs()
      .then((res) => {
        res.data.map((el) => {
          this.tabsData.push({ value: el.id, text: el.name });
        });
      })
      .catch((e) => {});
  },
};
</script>

<style>
.v-input {
  max-width: 25% !important;
}
.custom-options-width {
  max-width: 100% !important;
}
</style>
